import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-16 bg-ocean-cream" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-gray-100 text-center" data-id="element-74">
          <div className="w-20 h-20 bg-ocean-teal-light rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-75">
            <ShieldCheck className="w-10 h-10 text-ocean-teal" data-id="element-76" />
          </div>

          <h2 className="text-3xl font-bold mb-2" data-id="element-77">
            Tu compra está 100% protegida
          </h2>
          <h3 className="text-xl text-ocean-teal font-medium mb-6" data-id="element-78">
            Garantía total de 7 días
          </h3>

          <p className="text-gray-600 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-79">
            Tenés 7 días completos para explorar el material, revisar las
            herramientas y probar el sistema en tu casa. Si sentís que no era
            para vos, podés pedir la devolución. Riesgo cero para vos,
            compromiso total de nuestra parte.
          </p>
        </motion.div>
      </div>
    </section>;
}